(function (scope) {

scope.Footer = function () {
	var me = this;
	me._clickCloseOpens = [];
	$("footer a").each (function () {
		if ($(this).hasClass ("click-close-open")) me._clickCloseOpens.push (new ClickCloseOpen (this));
	});
};

}) (window);
